import { Logo as BrandLogo } from "@/components/Logo";
import { cn } from "@/lib/utils";

const presets = {
  sm: { mark: 32, wordmark: "text-base", slogan: "text-[0.6rem]" },
  md: { mark: 44, wordmark: "text-xl", slogan: "text-xs" },
  lg: { mark: 72, wordmark: "text-3xl", slogan: "text-sm" },
  xl: { mark: 128, wordmark: "text-5xl", slogan: "text-lg" },
} as const;

export interface BrandProps {
  /** "horizontal" for headers, "stacked" for heroes and footers. */
  layout?: "horizontal" | "stacked";
  /** Default "md". */
  size?: keyof typeof presets;
  /** Override the badge size without changing the wordmark scale. */
  markSize?: number;
  /** Optional styling for the badge independently of the wordmark. */
  markClassName?: string;
  /** Vertical badge offset in px, independent of the wordmark. */
  markOffsetY?: number;
  /** Show the slogan under the wordmark. Default true. */
  showSlogan?: boolean;
  animated?: boolean;
  className?: string;
}

/** Logo + "Problems" wordmark + slogan: the full brand lockup. */
export function Brand({
  layout = "horizontal",
  size = "md",
  markSize,
  markClassName,
  markOffsetY,
  showSlogan = true,
  animated = false,
  className,
}: BrandProps) {
  const preset = presets[size];
  return (
    <BrandLogo
      variant={layout}
      size={markSize ?? preset.mark}
      markClassName={markClassName}
      markOffsetY={markOffsetY}
      showSlogan={showSlogan}
      animated={animated}
      className={cn(layout === "stacked" && "mx-auto", className)}
      wordmarkClassName={preset.wordmark}
      sloganClassName={preset.slogan}
    />
  );
}
